// extracted by mini-css-extract-plugin
export var compactFilters = "_h3-4";
export var detailImage = "_h3-1";
export var dropdownContainer = "_h3-2";
export var imageContainer = "_h3-0";
export var selectedCard = "_h3-3";